import React from "react";

import { formatFieldAppDateTime } from "./fieldAppTimezoneDisplay";

function FieldAppScheduleWhen({ iso, timezoneMode }) {
  if (!iso) return null;
  return (
    <span className="field-app-telemetry-schedule__when">
      <span className="field-app-telemetry-schedule__when-time">
        {formatFieldAppDateTime(iso, timezoneMode, "hm")}
      </span>
      <span className="field-app-telemetry-schedule__when-date">
        {formatFieldAppDateTime(iso, timezoneMode, "dm")}
      </span>
    </span>
  );
}

export default FieldAppScheduleWhen;
